import { Intent } from "@blueprintjs/core"
import { useState } from "react"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import ConfirmButton from "src/libs/useful/ConfirmButton"
import Shortcode from "src/libs/useful/shortcode"
import { __ } from "src/libs/utilities"
import { IUser, useMainStore } from "src/settings/zustand"
import { useUser } from "src/settings/zustand/user"
import { IPETest, PE_TEST_AUTH_TYPE } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store"
import { actions } from "../../data/actions"
import { UPDATE_TEST_USER_RESULT_ACTION } from "../../data/actionTypes"
import { showToast } from "src/libs/useful"

/* Protopia Ecosystem component */
export interface IExternalFinishProps {
    item: IPETest
    results: any
}
const ExternalFinish = (props: IExternalFinishProps): JSX.Element => {
    const user = useUser()
    const lastResults = useTestsStore((state: ITestsStore) => state.lastResults )
    const [userData, setUserData] = useState<IUser>( user ) 
    switch(props.item.auth_type) {
        case PE_TEST_AUTH_TYPE.ANONYM:
            const onSend = () => {
                // console.log( props.results )
                // console.log( userData )
                const _lr = lastResults.filter( (result: any) => !(result.testId === props.item.id && result.user.id === user.id) )
                useTestsStore.setState({
                    lastResults: _lr
                })
                //
                actions(
                    UPDATE_TEST_USER_RESULT_ACTION, 
                    {
                        user_id: userData.id,
                        test_id: props.item.id,
                        results : JSON.stringify( props.results ),
                        user_data: JSON.stringify({
                            ...userData
                        }) 
                    }
                )
                .then(async () => {
                    showToast({
                        message: __("Results sended successfully")
                    })
                })
            }
            const onUser = ( user:IUser) => {
                setUserData( user )
            }
            return <div data-testid="external-finish">
                <Shortcode className="pe-external-finish-container" content={__("ANONYM_USER_MESSAGE")} data-testid="anonym-user-message"/>
                <div className="my-4 flex-centered w-100">
                    <ConfirmButton
                        onConfirm={onSend}
                        buttonLarge
                        buttonLabel={<span className="lead-md text-uppercase">{__("Send results")}</span>}
                        buttonIntent={Intent.DANGER}
                        yesLabel={__("Start sending results now")}
                        noLabel={__("Cancel")}
                        dialogClasssName={DIALOG_SIZE.NORMAL}
                        yesLock={!userData.school || !userData.age }
                    >
                        <ExternalFinishForm onUser={onUser} userData={userData} />
                    </ConfirmButton>
                </div>
            </div>
        default:
            return <div></div>
    }
    
}
export default ExternalFinish


interface IForm {
    onUser: (user:IUser) => void
    userData: IUser
}
export const ExternalFinishForm = ({onUser, userData}: IForm): JSX.Element => {
    const onchange = (field: string, value: string | number, ) => {
        const dt = {
            ...userData,
            [field]: value.toString()
        }
        useMainStore.setState({anonymUser : dt })
        onUser( dt )
    }
    return <div className="p-5" data-testid="external-finish-form">
        <div className="descr text-center mb-4">
            {__("Please provide the required information.")}
        </div>
        <FieldInput
            editable
            commentary={__("This is optional field")}
            value={userData.display_name}
            title={__("Your name")} 
            onChange={(val)  => onchange("display_name",val)}
            data-testid="external-finish-display-name"
        />
        <FieldInput
            editable
            value={userData.age}
            type={SCALAR_TYPES.NUMBER}
            required
            title={__("Your age")} 
            onChange={(val)  => onchange("age",val)}
            data-testid="external-finish-age"
        />
        <FieldInput
            editable
            required
            value={userData.school}
            title={__("Your educational organization")} 
            onChange={(val)  => onchange("school", val, )}
            data-testid="external-finish-school"
        />
    </div>
}